import axios from 'axios';

export async function login(email, password) {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
        email,
        password
    });
    return res.data.data;
}
